import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const InsertBelowIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "insert-below",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M10.5 14.5H14.5M12.5 12.5V16.5M6.5 19.5H18.5M6.5 5.5H18.5V9.5H6.5V5.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	});
});
export { InsertBelowIcon, InsertBelowIcon as default };

//# sourceMappingURL=InsertBelow.js.map